import type {
  TInvalidRecords,
  TUserUploadError,
} from './components/Step2/hooks/useDataValidation/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNestedTypeGuard(arg: any): arg is TUserUploadError {
  return arg && arg.subErrors !== undefined;
}

export function getErrorsToDisplay(
  errors: TInvalidRecords[],
  codes: number[] | undefined,
): TInvalidRecords[] {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (codes === undefined) return [];

  const isNested = isNestedTypeGuard(errors[0]);

  if (isNested) {
    return (
      errors?.filter(error => {
        return codes.includes(error.code || 0);
      }) || []
    );
  }

  return errors; //TODO: Here it should actually filter the errors by the codes, but several InvalidUsers dependent queries dont support error codes or multiple details yet
}

export const getTotalNestedErrors = (allErrors: TInvalidRecords[]) => {
  return allErrors.reduce((acc, error) => {
    const subErrors = error.subErrors || [];
    const subErrorsCount = subErrors.reduce(
      (subAcc, subError) => subAcc + (subError?.errors?.length || 0),
      0,
    );
    return acc + subErrorsCount;
  }, 0);
};
